import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import BgCastle from "../assets/bg-castle2.png";
import Bg from "../assets/bg-grid.svg";
import Wood from "../assets/wood2.png";
import ContinueBtn from "../assets/continue-orange.png";
import Text from "./Text";
import Button from "./Button";
import { updateGameplayCount } from "../API/progress";
import { startNewGameplay } from "../utils/gameplay";

const GameWinPageWrapper = styled.div`
  z-index: 9999;
  height: 100%;
  width: 100%;
  background-color: #3e626a;
  background-image: url(${Bg});
  background-position: center;
  background-size: cover;

  position: absolute;

  display: flex;
  justify-content: center;
  flex-direction: unset !important;
  align-items: end;
`;

const ContentWrapper = styled.div`
  margin: 35px 200px 0 200px;
  width: 90%;
  height: 85%;

  background-color: #fffbec;
  background-image: url(${BgCastle});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  border-radius: 10px;
`;

const GreenLineExternal = styled.div`
  height: 100%;
  margin: 20px 20px 0 20px;
  border-top: 1px solid #3e626a;
  border-left: 1px solid #3e626a;
  border-right: 1px solid #3e626a;
`;

const GreenLineInternal = styled.div`
  height: 100%;
  margin: 5px 5px 0 5px;
  border-top: 1px solid #3e626a;
  border-left: 1px solid #3e626a;
  border-right: 1px solid #3e626a;
`;

const TextContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-top: 140px;
`;

const TitleWrapper = styled.div`
  position: relative;

  margin-bottom: 20px;
`;

const WoodBg = styled.img``;

const StyledText = styled.p`
  font-family: 'Source Serif 4';
  font-size: 70px;
  font-weight: 700;
  color: #3e626a;
  line-height: 100%;

  position: absolute;
  top: 65%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
`;

export const GameWin = () => {
  const navigate = useNavigate();

  const handleReplay = async () => {
    const userId = sessionStorage.getItem("user_id");
    const conqueredCastles = sessionStorage.getItem("conquered_castles");
    const conqueredColors = sessionStorage.getItem("conquered_castle_colors");

    // ✅ Start new gameplay (update session + backend)
    await startNewGameplay(userId);

    // ✅ Clear and restore essentials
    sessionStorage.clear();
    if (conqueredCastles)
      sessionStorage.setItem("conquered_castles", conqueredCastles);
    if (conqueredColors)
      sessionStorage.setItem("conquered_castle_colors", conqueredColors);
    sessionStorage.setItem("user_id", userId);
    sessionStorage.setItem("allow_replay_conquered", "true");

    navigate("/leaderboard");
  };

  return (
    <GameWinPageWrapper>
      <ContentWrapper>
        <GreenLineExternal>
          <GreenLineInternal>
            <TextContainer>
              <TitleWrapper>
                <WoodBg src={Wood} />
                <StyledText>Νίκη</StyledText>
              </TitleWrapper>

              <Text
                fontFamily="Manrope"
                fontSize="20px"
                fontWeight="500"
                color="#3e626a"
                lineheight="100%"
                padding="0 0 80px 0"
              >
                Kατέκτησατε όλα τα κάστρα!
              </Text>

              <Button style={{ marginTop: "100px" }} onClick={handleReplay} imgurl={ContinueBtn} />
            </TextContainer>
          </GreenLineInternal>
        </GreenLineExternal>
      </ContentWrapper>
    </GameWinPageWrapper>
  );
};
